module.exports = __webpack_public_path__ + "static/media/HelveticaNikePlus_Bold.f8840f05.otf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/fonts/HelveticaNikePlus/HelveticaNikePlus_Bold.otf
// module id = 735
// module chunks = 0